import React from "react";
import { Container } from "./Styled";
import { ResponsiveLine } from "@nivo/line";
import BaseChart from "../baseChart/BaseChart";

type LineProps = {
    className?: string;
    data?: any;
    color?: string;
    title: string
};

export const Line: React.FunctionComponent<LineProps> = ({
    className,
    data,
    color,
    title
}) => {

    const CustomSymbol = (data: any) => (
        <g>
            <circle
                fill="#fff"
                r={data.size / 1.5}
                strokeWidth={data.borderWidth}
                stroke={data.borderColor}
            />
            <circle
                r={data.size / 5}
                strokeWidth={data.borderWidth}
                stroke={data.borderColor}
                fill={data.color}
                fillOpacity={0.35}
            />
        </g>
    );

    return (
        <Container>
            <BaseChart title={title}>
                    <ResponsiveLine
                        data={data}
                        margin={{ top: 30, right: 40, bottom: 60, left: 60 }}
                        xScale={{ type: "point" }}
                        yScale={{
                            type: "linear",
                            min: "auto",
                            max: "auto",
                            stacked: true,
                            reverse: false
                        }}
                        // @ts-ignore
                        curve="monotoneX"
                        axisTop={null}
                        axisRight={null}
                        pointSize={10}
                        pointBorderWidth={1}
                        pointBorderColor={{
                            from: "color",
                            modifiers: [["darker", 0.3]]
                        }}
                        axisBottom={{
                            orient: 'bottom',
                            tickSize: 0,
                            tickPadding: 20,
                            tickRotation: 0,
                            legendOffset: 36,
                            legendPosition: 'middle'
                        }}
                        pointLabel="y"
                        pointSymbol={CustomSymbol}
                        pointLabelYOffset={-12}
                        enableArea={true}
                        useMesh={true}
                        areaOpacity={0.05}
                        colors={color ? color : '#1890FF'}
                        enableGridY={false}
                        // @ts-ignore
                        areaBaselineValue={0}
                    />
                </BaseChart>
        </Container>
    );
};

export default Line;
